export default "__VITE_ASSET__CI9qzENK__"